import { render, staticRenderFns } from "./FoShanOverview.vue?vue&type=template&id=46a72709&scoped=true&"
import script from "./FoShanOverview.vue?vue&type=script&lang=js&"
export * from "./FoShanOverview.vue?vue&type=script&lang=js&"
import style0 from "./FoShanOverview.vue?vue&type=style&index=0&id=46a72709&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a72709",
  null
  
)

export default component.exports